module.exports = __webpack_public_path__ + "img/logopdf.e1c59bc0.png";